export const discover =
    [
        {
            title: "The World Until Yesterday",
            author: "Jared Diamond",
            image: "http://books.google.com/books/content?id=nech105NsugC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
        },
        {
            title: "The Song of Achilles",
            author: "Madeline Miller",
            image: "http://books.google.com/books/content?id=opC3d3ltQ94C&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
        },
        {
            title: "Algorithms to Live By",
            author: "Brian Christian",
            image: "http://books.google.com/books/content?id=Ydn_CwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
        },
        {
            author: "Steve Krug",
            image: "http://books.google.com/books/content?id=g1QBFJxB_eEC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
            title: "Don't Make Me Think"
        },
        {
            title: 'Into Thin Air', author: 'Jon Krakauer', image: "http://books.google.com/books/content?id=gt7EQgH8-b4C&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
        },
        { title: 'All the Light We Cannot See', author: 'Anthony Doerr', image: "http://books.google.com/books/content?id=giaLDgAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api" },
        { title: 'The Wild Trees', author: 'Richard Preston', image: "http://books.google.com/books/content?id=i5zwGGg6y28C&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api" },
        { title: 'The Immortal Life of Henrietta Lacks', author: 'Rebecca Skloot', image: "http://books.google.com/books/content?id=GFevO-QxQDgC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api" },
        {
            title: 'The Glass Castle', author: 'Jeannette Walls', image: "http://books.google.com/books/content?id=BTMknk-qvacC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
        },
        {
            title: 'Flow', author: 'Mihaly Csikszentmihalyi', image: "http://books.google.com/books/content?id=QVjPsd1UukEC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
        },
        {
            title: "The Queen's Gambit", author: 'Walter Tevis', image: "http://books.google.com/books/content?id=i2hsDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
        },
        {
            title: 'The Other Einstein', author: 'Marie Benedict', image: "http://books.google.com/books/content?id=fr0HDAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
        },
        {
            title: 'The Martian', author: 'Andy Weir', image: "http://books.google.com/books/content?id=OPAgEAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
        },
        {
            title: 'The Kite Runner', author: 'Khaled Hosseini', image: "http://books.google.com/books/content?id=MH48bnzN0LUC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api"
        }


    ]
